"use client";
import { Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography";
import { toAssetImages } from "src/lib/utils";
import React from "react";
import SalifyLink from "src/lib/components/link/salify-link";
import { FlexBox } from "../../salify-next-layout/default/components/flex-box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Grid } from "@mui/material";
import { StyledButton } from "./styles";

const CategoryList = ({ categoryList }) => {
  const isMobile = useMediaQuery("(max-width:767px)");
  return (
    <div>
      {categoryList.map((item, ind) => (
        <FlexBox
          key={ind}
          style={{
            backgroundColor: ind % 2 === 0 ? "#edf5e4" : "#faece8",
            margin: "20px",
            padding: "20px",
            borderRadius: "20px",
            minHeight: "166px",
          }}
        >
          <div
            style={{
              minWidth: isMobile ? "100%" : "560px",
              backgroundImage: `url(${toAssetImages(item.imgUrl)})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right",
            }}
          >
            <div style={{ color: "black", fontSize: "16px" }}>{item.name}</div>
            <Paragraph style={{ color: "black", fontSize: "28px" }}>{item.subTitle}</Paragraph>
            {item.leftButton && (
              <Grid item>
                <SalifyLink href={item.leftButton.link}>
                  <StyledButton variant="contained" color="primary">
                    {item.leftButton.text}
                  </StyledButton>
                </SalifyLink>
              </Grid>
            )}
          </div>
        </FlexBox>
      ))}
    </div>
  );
};

export default CategoryList;
